enum Features {
  GLOBAL_FEATURE_MANAGEMENT = 'global_console_feature_management',
}

export default Features;
